/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import * as globals from "../globals";

export default function TwitterFeed(props) {
  const script = document.createElement("script");

  script.src = "https://platform.twitter.com/widgets.js";
  script.async = true;

  document.body.appendChild(script);
  return (
    <div
      css={css`
        ${globals.card}
        padding: 10px 10px 0;
        min-height: 514px;
      `}
    >
      <a
        className="twitter-timeline"
        data-height="500"
        href="https://twitter.com/dailybruin?ref_src=twsrc%5Etfw"
      >
        Tweets by dailybruin
      </a>
    </div>
  );
}
